import React from "react"
import { ResultRowShell } from "./result_row_shell"
import { CategoryIcon } from "../category_icon"
import type { SearchRowComponent } from "./types"

// A topic (taxonomy) result: a hash glyph and the topic name.
export const TopicRow: SearchRowComponent = ({ hit, position, onSelect }) => (
  <ResultRowShell hit={hit} position={position} onSelect={onSelect}>
    <CategoryIcon category="Topics" className="shrink-0 text-secondary-400" />
    <span className="truncate">{hit.name}</span>
  </ResultRowShell>
)
